import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
const fallbackLng = 'en';
const availableLanguages = ['en', 'pl'];
i18n.use(Backend) // load translations using http (default: public/assets/locals/en/translations)
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
    fallbackLng,
    backend: {
        /* translation file path */
        loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
    },
    detection: {
        checkWhitelist: true // options for language detection
    },
    debug: false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ','
    },
    react: {
        useSuspense: true
    }
});
export default i18n;
const t = i18n.t.bind(i18n);
export { t, availableLanguages };
